export default {
    blink: {
        targets: '#aye_left_eye, #aye_right_eye',
        // scaleY: [
        //     { value: 0, duration: 100 },
        //     { value: 1, duration: 100 },
        //     { value: 0, duration: 100, delay: 100 },
        //     { value: 1, duration: 100 }
        // ], // not consistent in firefox
        easing: 'linear',
        delay: 5000,
        loop: true
    },
    ria_sway: {
        targets: '#ria',
        rotate: '1deg',
        easing: 'linear',
        direction: 'alternate',
        duration: 2500,
        loop: true
    },
    tube: {
		open: {
			targets: '#Glass',
			scaleY: '0',
			duration: 800,
			easing: 'easeOutCubic'
		},
		close: {
			targets: '#Glass',
			scaleY: '1',
			duration: 800,
			easing: 'easeInCubic'
		}
    },
    wave: {
        wave_main_arm: {
            targets: '#Aye #Right_Arm',
            rotate: [
                { value: '90deg' },
                { value: '0', delay: 500 }
            ],
            translateX: [
                { value: '50px' },
                { value: '0', delay: 500 },
            ],
            autoplay: false,
            elasticity: 0,
            easing: 'linear'
        },
        wave_fore_arm: {
            targets: '#Aye #Right_Fore_Arm',
            rotate: [
                { value: '90deg' },
                { value: '0', delay: 500 }
            ],
            translateX: [
                { value: '-10px' },
                { value: '0', delay: 300 },
            ],
            offset: '-=1000',
            elasticity: 300,
			direction: 'alternate'
        }
    },
	fingerprint: {
		targets: '#fingerprint_1, #fingerprint_2, #fingerprint_3, #fingerprint_4, #fingerprint_5',
		fill: '#A0D1F2',
		easing: 'linear',
		direction: 'alternate',
		loop: true
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/animations.js